import React from 'react';

const Header: React.FC = () => {
  return (
    <header className="bg-gray-800 p-4 flex justify-between items-center shadow">
      <h1 className="text-xl font-bold">Generic Dashboard</h1>
      <div className="flex items-center space-x-4">
        <span>User</span>
        {/* Future: Add profile dropdown */}
      </div>
    </header>
  );
};

export default Header;
